const SECONDS_PER_MINUTE = 60;
const SECONDS_PADDING = 2;

/**
 * Renders a remaining duration as `m:ss`. Deliberately not a plural i18n key: the missing-key CI
 * gate compares extracted keys verbatim and does not normalise plural families, so every suffix
 * variant would have to exist remotely before this could ship.
 */
const formatCountdown = (totalSeconds: number): string => {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safeSeconds / SECONDS_PER_MINUTE);
  const seconds = safeSeconds % SECONDS_PER_MINUTE;

  return `${minutes}:${String(seconds).padStart(SECONDS_PADDING, "0")}`;
};

export default formatCountdown;
